import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

class FooterMobile extends Component {

    render() {

        return (
            <Fragment>

                <div className="footerback m-0 mt-5 pt-3 shadow-sm">

                    <Container className="text-center">

                        <Row className="px-0 my-5">

                            {/* OFFICE ADDRESS */}
                            <Col
                                className="p-2"
                                lg={6}
                                md={6}
                                sm={6}
                                xs={12}
                            >

                                <h5 className="footer-menu-title">
                                    OFFICE ADDRESS
                                </h5>

                                <p>
                                    Al Qusais Ind. First - Dubai - United Arab Emirates
                                    <br />

                                    Email:
                                    <a
                                        href="mailto:Support@easylearningbd.com"
                                        className="footer-link"
                                    >
                                        Booking@dxblimo.com
                                    </a>
                                </p>


                                {/* SOCIAL LINKS */}
                                <h5 className="footer-menu-title">
                                    SOCIAL LINK
                                </h5>

                                <a
                                    href="#"
                                    aria-label="Facebook"
                                >
                                    <i className="fab m-1 h4 fa-facebook"></i>
                                </a>

                                <a
                                    href="#"
                                    aria-label="Instagram"
                                >
                                    <i className="fab m-1 h4 fa-instagram"></i>
                                </a>

                                <a
                                    href="#"
                                    aria-label="Twitter"
                                >
                                    <i className="fab m-1 h4 fa-twitter"></i>
                                </a>

                            </Col>


                            {/* COMPANY */}
                            <Col
                                className="p-2"
                                lg={6}
                                md={6}
                                sm={6}
                                xs={12}
                            >

                                <h5 className="footer-menu-title">
                                    THE COMPANY
                                </h5>

                                <Link
                                    to="/"
                                    className="footer-link"
                                >
                                    About Us
                                </Link>

                                <br />

                                <Link
                                    to="/"
                                    className="footer-link"
                                >
                                    Company Profile
                                </Link>

                                <br />

                                <Link
                                    to="/"
                                    className="footer-link"
                                >
                                    Contact Us
                                </Link>

                                <br />

                                <h5 className="footer-menu-title mt-4">
                                    MORE INFO
                                </h5>

                               <Link
                                    to="/privacy-policy"
                                    className="footer-link"
                                            >
    Privacy Policy
</Link>

                                <br />

                              <Link
    to="/refund-policy"
    className="footer-link"
>
    Refund Policy
</Link>

                            </Col>

                        </Row>

                    </Container>


                    {/* COPYRIGHT */}
                    <Container
                        fluid={true}
                        className="text-center m-0 pt-3 pb-1 bg-dark"
                    >

                        <Container>

                            <Row>

                                <h6 className="text-white w-100">
                                    © Copyright 2021 by Al Saad Qatar,
                                    All Rights Reserved
                                </h6>

                            </Row>

                        </Container>

                    </Container>

                </div>

            </Fragment>
        )
    }
}

export default FooterMobile